import Image from 'next/image';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <div className={cn("flex items-center", className)}>
      <Image
        src="/logos/umynd.logo.left.blue.svg"
        alt="Umynd Logo"
        priority
        width={198}
        height={48}
        className="w-auto h-12"
      />
    </div>
  );
} 